let isSessionEndInSameClient = false;

export function setIsSessionEndInSameClient(nextStatus: boolean) {
  isSessionEndInSameClient = nextStatus;
}

export function getIsSessionEndInSameClient() {
  return isSessionEndInSameClient;
}
